import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import React, { useEffect } from "react";
import {
  AdyenInstance,
  useConfiguredAdyenInstance,
} from "../../../checkout-page-layout/CheckoutComponent/adyen/use-adyen-instance";
import { PaymentAction } from "@adyen/adyen-web/dist/types/types";
import type { CreditCardResponseResultChallengeData } from "@swo/storefront";

const myAdyenContainer = "adyen-container";

export const Payment3DSChallenge: ReactTFC<{
  action: CreditCardResponseResultChallengeData;
  onError: () => void;
  on3DSecureResult: (token: string) => void;
}> = props => {
  const adyenInstance = useConfiguredAdyenInstance(
    (state, component) => {
      const token = (state as any)?.data?.details?.threeDSResult;
      if (token && typeof token === "string") {
        props.on3DSecureResult(token);
      } else {
        console.error("Invalid state", state);
        props.onError();
      }
    },
    (state, component) => {
      console.log(state, component);
    },
  );

  if (!adyenInstance) {
    return null;
  }

  return <Payment3DSChallengeInstance {...props} instance={adyenInstance.underlying} />;
};

export const Payment3DSChallengeInstance: ReactTFC<{
  action: CreditCardResponseResultChallengeData;
  onError: () => void;
  on3DSecureResult: (token: string) => void;
  instance: AdyenInstance["underlying"];
}> = props => {
  function getChallengeWindowSize(w: number) {
    // Set to any of the following:
    // '02': ['390px', '400px'] -  The default window size
    // '01': ['250px', '400px']
    // '03': ['500px', '600px']
    // '04': ['600px', '400px']
    // '05': ['100%', '100%']

    if (w > 500) {
      return "02";
    } else {
      return "01";
    }
  }

  useEffect(() => {
    const i = props.instance;
    const w = window.innerWidth;

    const threeDSConfiguration = {
      challengeWindowSize: getChallengeWindowSize(w),
      onError: (err: unknown) => {
        console.error("3ds error", err);
        props.onError();
      },
    };

    const uiElement = i.createFromAction(props.action as PaymentAction, threeDSConfiguration);

    uiElement.mount(`#${myAdyenContainer}`);

    return () => {
      uiElement.remove();
    };
  }, [props.instance]);

  return <div id={myAdyenContainer} />;
};
